export const getLocalStorageSelectedAzienda = () => {
    try {
        const item = localStorage.getItem("selectedAzienda");
        return item ? JSON.parse(item) : null;
    } catch (error) {
        console.error("Error getting localStorage selectedAzienda:", error);
        return null;
    }
}
export const setLocalStorageSelectedAzienda = (azienda) => {
    localStorage.setItem("selectedAzienda", JSON.stringify(azienda));
}
export const getLocalStorageImportType = () => {
    return localStorage.getItem("importType");
}
export const setLocalStorageImportType = (type) => {
    localStorage.setItem("importType", type);
}
export const getLocalStorageSelectedFascicolo = () => {
    try {
        const item = localStorage.getItem("selectedFascicolo");
        return item ? JSON.parse(item) : null;
    } catch (error) {
        console.error("Error getting localStorage selectedFascicolo:", error);
        return null;
    }
}
export const setLocalStorageSelectedFascicolo = (fascicolo) => {
    localStorage.setItem("selectedFascicolo", JSON.stringify(fascicolo));
}
export const removeLocalStorageSelectedFascicolo = (fascicoloId) => {
    const selected = getLocalStorageSelectedFascicolo();
    if (fascicoloId !== undefined && (selected?.id ?? selected) !== fascicoloId) {
        return;
    }
    localStorage.removeItem("selectedFascicolo");
    localStorage.removeItem("selectedEntity");
}
export const getLocalStorageSelectedEntity = () => {
    try {
        const item = localStorage.getItem("selectedEntity");
        return item ? JSON.parse(item) : null;
    } catch (error) {
        console.error("Error getting localStorage:", error);
        return null;
    }
}
export const setLocalStorageSelectedEntity = (entityType, entityId, options) => {
    const item = { entityType: entityType, entityId: entityId, options: options };
    localStorage.setItem("selectedEntity", JSON.stringify(item));
}
export const removeLocalStorageSelectedEntity = () => {
    localStorage.removeItem("selectedEntity");
}
export const getLocalStorageSelectedAutovalutazione = () => {
    try {
        const item = localStorage.getItem("selectedAutovalutazione");
        return item ? JSON.parse(item) : null;
    } catch (error) {
        console.error("Error getting localStorage selectedAutovalutazione:", error);
        return null;
    }
}
export const setLocalStorageSelectedAutovalutazione = (autovalutazione) => {
    localStorage.setItem("selectedAutovalutazione", autovalutazione);
}

// Backward compatibility - factory function
export const StorageHelpers = () => {
    return {
        GetLocalStorageSelectedAzienda: getLocalStorageSelectedAzienda,
        SetLocalStorageSelectedAzienda: setLocalStorageSelectedAzienda,
        GetLocalStorageImportType: getLocalStorageImportType,
        SetLocalStorageImportType: setLocalStorageImportType,
        GetLocalStorageSelectedFascicolo: getLocalStorageSelectedFascicolo,
        SetLocalStorageSelectedFascicolo: setLocalStorageSelectedFascicolo,
        GetLocalStorageSelectedEntity: getLocalStorageSelectedEntity,
        SetLocalStorageSelectedEntity: setLocalStorageSelectedEntity,
        RemoveLocalStorageSelectedEntity: removeLocalStorageSelectedEntity,
        GetLocalStorageSelectedAutovalutazione: getLocalStorageSelectedAutovalutazione,
        SetLocalStorageSelectedAutovalutazione: setLocalStorageSelectedAutovalutazione
    }
}
